module.exports = __webpack_public_path__ + "static/media/icomoon.37849015.ttf";